import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 12 12\" id=\"plus\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.6 10.875c0 .207.18.375.4.375.22 0 .4-.168.4-.375V6.4h4.453c.22 0 .397-.18.397-.4 0-.22-.178-.4-.397-.4H6.4V1.125C6.4.918 6.22.75 6 .75c-.22 0-.4.168-.4.375V5.6H1.147A.398.398 0 0 0 .75 6c0 .22.178.4.397.4H5.6v4.475Z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol